export default __webpack_public_path__ + "static/media/5.e58d4104.jpg";